import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "@/components/common/Image";
import Icon from "@/components/icon/Icon";
import { Sizes, UCILogo } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import BooksBadge from "@/modules/products/components/ProductDetail/BooksBadge";
import { DEFAULT_BOOK_COVER } from "@/settings/constant";
import { Button } from "antd";
import ExpertVariantLink from "./ExpertVariantLink";
import { ImageSection, UCIPromotionBox } from "./HandoutProductDetail.style";
export const HandoutImageSection = (param)=>{
    let { thumbImg , title , openPreviewModal , isBooks , hasPreviewImg , uciData , product  } = param;
    const { isMobile  } = useWindowDimensions();
    return /*#__PURE__*/ _jsxs(ImageSection, {
        className: "new-col",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "img_box",
                children: /*#__PURE__*/ _jsx(Image, {
                    className: "thumb-img",
                    src: thumbImg !== null && thumbImg !== void 0 ? thumbImg : DEFAULT_BOOK_COVER,
                    alt: "product-thumbImg-".concat(title),
                    width: 244,
                    height: 347
                })
            }),
            !isBooks && hasPreviewImg && /*#__PURE__*/ _jsx(Button, {
                className: "preview-btn",
                onClick: ()=>{
                    openPreviewModal();
                    mixpanelEvent("Product Detail Page_Preview");
                },
                children: "샘플 보기"
            }),
            !isBooks && product && /*#__PURE__*/ _jsx(ExpertVariantLink, {
                product: product
            }),
            isBooks && /*#__PURE__*/ _jsx(BooksBadge, {}),
            uciData && /*#__PURE__*/ _jsxs(UCIPromotionBox, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: UCILogo,
                        size: isMobile ? Sizes.small : Sizes.large
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: uciData
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "hide_m",
                                children: "해당 자료는 국가콘텐츠식별체계를 통해 유통 및 관리됩니다."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
